/**
 * The interaction prompt's label for a verb (P1.9-T17; ADR-061, amendment "the export is a visual reference"): the
 * contract verb with underscores as spaces, in sentence case, so `read` reads "Read" and `pick_up` "Pick up". It is
 * provisional: where player-facing verb labels come from is the brief's question 15, open for the author, and a
 * label table the contract carries would replace this rule. A verb the protocol carries is lower-case letters and
 * underscores, so every label is set in the pixel face's glyphs.
 */

import { say } from "../../../words.ts";
import { HARVEST_VERB } from "../../harvest/look.ts";

/**
 * The label a verb reads as. `harvest`, the verb of the grass rather than of a thing's contract, reads as the language
 * files' word for it (`harvest.action`).
 *
 * @param verb A verb name the contract declares, such as `lower`.
 * @returns The label, such as "Lower".
 * @example
 * verbLabel("light_the_lamp");
 * // "Light the lamp"
 */
export function verbLabel(verb: string): string {
  if (verb === HARVEST_VERB) {
    return say("harvest.action");
  }
  const spaced = verb.replaceAll("_", " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
